<template>
		<v-row justify-sm="center" v-if="featured">
			<v-col cols="12">
				<v-carousel
					cycle
					continuous
					show-arrows
					height="340"
					show-arrows-on-hover
					hide-delimiters
					light
					v-if="showFeatured"
				>
					<v-carousel-item v-for="(item, i) in items" :key="i" >
						<v-card class="rounded-card" max-width="100%" light>
							<v-img
								height="150"
								:src="item.photo_url"
							>
								<v-row  class=" pa-2">
									<v-col align="right">
										<v-btn small color="white" class=" rounded"><h2 class="price " v-html="`${item.price}`"/></v-btn>
									</v-col>
								</v-row>

							</v-img>
						<v-list-item-content >

							 <p align="right" class="name px-4" >{{item.nameEN}} </p>
							 <hr>
							 <p align="right" class="description px-4">{{item.descriptionEN}} </p>
							 <p align="right" class="description px-4">{{item.description1EN}} </p>
							 <p align="right" class="description px-4">{{item.description2EN}} </p>


							<v-row  class=" px-8">

									<p  style=" max-width: 30px; margin: 0px;" v-for="aler in  item.alergenos" :key="aler.id" class="chips">
									<img class="alergenos" :src="`/static/alergenos/${aler}.jpg`" />
									</p>

							</v-row>
						</v-list-item-content>
						</v-card>
					</v-carousel-item>
				</v-carousel>
			</v-col>
		</v-row>
</template>

<script>
	import { mapState, mapActions } from "vuex";
  import { db } from "@/main";
  export default {
		mounted(){
				db.collection('bussiness')
					.doc(this.$route.params.id).collection('items')
					.where('visible','==', true)
					.where('featured','==',true)
					.onSnapshot(snap => {
					if (snap.empty) {
						console.log('Not matching documents.')
						return
					}
					snap.forEach(doc => {
						this.items.push( doc.data() )
					})

					this.featured = true;
				})
		},
    data: () => ({
      businessId: '',
			featured: false,
			loading: true,
			items: [],
    }),

    methods: {

		},
		computed: {
			...mapState(['showFeatured']),
		}
  }
</script>
<style>
	.rounded-card {
		border-radius:20px !important;
		border: 0px solid #ccc !important;
		box-shadow: 5px 5px 6px 3px rgba(0, 0, 0, 0.2)
	}
	.rounded-price {
		border-radius:10px !important;
		border: 0px solid #ccc !important;
		box-shadow: 5px 5px 6px 3px rgba(0, 0, 0, 0.2)

	}
	.name {
		font-family: 'Roboto', sans-serif;
		font-weight: 400;
		line-height: normal !important;

		font-size: 20px;
	}
	.price {
		font-family: 'Roboto', sans-serif;
		font-weight: 400;
		line-height: normal !important;
		font-size: 20px;
	}
	.description {
		font-family: 'Roboto', sans-serif;
		font-weight: 300;
		line-height: 1 !important;
		margin-top: 5px;

	}
	.alergenos {
		width: 80%;
	}

</style>
